import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('conversations-message-history', {
  library: 'conversations-message-history'
});